import { PaginationControls } from "@/components/_molecules/pagination-controls";

import { useDatatableContext } from "./use-datatable-context";

export function DatatablePagination() {
  const { table, isPaginationEnabled } = useDatatableContext();

  if (!isPaginationEnabled) {
    return null;
  }

  return (
    <PaginationControls
      page={table.getState().pagination.pageIndex}
      pageCount={table.getPageCount()}
      onPrevious={() => table.previousPage()}
      onNext={() => table.nextPage()}
      className="px-4"
    />
  );
}
